import { PLAYER_SINGLE } from '../constants/AppConstants';
import CharacterSimple from '../seek/CharacterSimple';

export default class OverlayResult extends Phaser.Image {
  constructor(game, seekerId, charsData) {
    super(game, 0, 0, 'bg_result');

    this.seekerId = seekerId;

    //
    this.onCloseResult = new Phaser.Signal();

    // add bg
    this.bgTop = this.game.make.image(this.game.defaultWidth * 0.5, 0, 'bg_welldone_top');
    this.bgTop.anchor.set(0.5, 0);
    this.addChild(this.bgTop);
    this.bgBtm = this.game.make.image(
      this.game.defaultWidth * 0.5,
      this.game.defaultHeight,
      'bg_welldone_btm'
    );
    this.bgBtm.anchor.set(0.5, 1);
    this.addChild(this.bgBtm);

    // add characters
    charsData = charsData.concat(); // make a copy
    charsData.unshift({ id: seekerId });
    this.addCharacters(charsData);

    // lock content under
    this.inputEnabled = true;

    //
    this.events.onInputDown.addOnce(this.handleInputDown, this);
    this.game.time.events.add(4000, this.handleInputDown, this);

    // play audio for single player mode only
    const textId = 'cs_10a_group_001';
    this.game.springRollCaptionsPlugin.setData(this.game.cache.getJSON('vo_ui_captions'));
    this.game.springRollCaptionsPlugin.playCaption(textId);
    this.game.sounds.playVO(textId, { spriteID: 'vo_ui' });
    PLAYER_SINGLE;
    /*
    if (this.game.controller.playerMode === PLAYER_SINGLE) {
      this.game.springRollCaptionsPlugin.setData(this.game.cache.getJSON('vo_ui_captions'));
      const charId = this.game.controller.nextSeekerId;
      let textId = 'vo_01_' + charId + '_010';
      if (this.game.controller.isNextLevelHiding()) {
        textId = 'cs_10b_elinor_04';
      }
      this.game.springRollCaptionsPlugin.playCaption(textId);
      this.game.sounds.playVO(textId, { spriteID: 'vo_ui' });
    }
    */
  }

  addCharacters(charsData) {
    // add characters
    const count = charsData.length;
    const dx = 165;
    const x0 = -(count - 1) * 0.5 * dx;
    this.charsGroup = this.game.make.group();
    this.charsGroup.x = this.game.defaultWidth / 2;
    this.charsGroup.y = 540;
    for (let i = 0; i < count; i++) {
      const id = charsData[i].id;
      const x = x0 + i * dx;
      const y = 0; // id === this.seekerId ? -20 : 0;
      let char = new CharacterSimple(this.game, x, y, id, i < count / 2 ? 'right' : 'left');
      char.playAnim('cheering', true);
      this.charsGroup.addChild(char);

      // mary
      if (id === 'twins') {
        char.x += 40;
        char = new CharacterSimple(this.game, x - 40, y, 'mary', i < count / 2 ? 'right' : 'left');
        char.playAnim('cheering', true);
        this.charsGroup.addChild(char);
      }
    }
    this.addChild(this.charsGroup);
  }

  update() {
    this.charsGroup.update();
    super.update();
  }

  handleInputDown() {
    this.events.onInputDown.remove(this.handleInputDown, this);

    this.game.springRollCaptionsPlugin.stopCaption();
    this.game.sounds.stopAudioSprite('cs_10a_group_001', { spriteID: 'vo_ui' });

    this.onCloseResult.dispatch();
  }
}
